import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchAllReports = createAsyncThunk(
  'reports/fetchAllReports',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('https://the-pivot-logical-battleground.onrender.com/api/admin/dashboard', {
        headers: { Authorization: `Bearer ${token}` }
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 2. 신고 처리하기 (반려/승인)
export const processReport = createAsyncThunk(
  'reports/processReport',
  async ({ targetId, targetType, action }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.put(`https://the-pivot-logical-battleground.onrender.com/api/admin/action/${targetId}`, 
        { action, targetType }, 
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return { targetId, targetType, message: res.data.message };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const submitReport = createAsyncThunk(
  'reports/submitReport',
  async (reportData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post('https://the-pivot-logical-battleground.onrender.com/api/reports', reportData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const reportsSlice = createSlice({
  name: 'reports',
  initialState: {reports: { posts: [], comments: [] }, stats: null, loading: false, error: null},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitReport.pending, (state) => { state.loading = true; })
      .addCase(submitReport.fulfilled, (state) => { state.loading = false; })
      .addCase(submitReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllReports.pending, (state) => { state.loading = true; })
      .addCase(fetchAllReports.fulfilled, (state, action) => {
        state.loading = false;
        state.reports = action.payload.reports;
        state.stats = action.payload.stats;
      })
      .addCase(processReport.fulfilled, (state, action) => {
        const { targetId, targetType } = action.payload;
        if (targetType === 'Post') {
          state.reports.posts = state.reports.posts.filter(p => p._id !== targetId);
        } else {
          state.reports.comments = state.reports.comments.filter(c => c._id !== targetId);
        }
      });
  },
});

export default reportsSlice.reducer;